export const options_messageList_previewShow = "YUd";
export const options_messageList_previewHide = "ZUd";
export const options_messageList_previewLabel = "_Ud";
export default {options_messageList_previewShow,options_messageList_previewHide,options_messageList_previewLabel};